export default function orderRotationForColor(order: number) {
  if (Number.isNaN(+order) || order < 1) return 1;
  return ((order - 1) % 10) + 1;
}
